import fetch from '../fetch';
import { errorMessages } from '../../constants';

export const CHANGE_BILLING_DATE = 'CHANGE_BILLING_DATE';
export const BILLING_DATE_CHANGED = 'BILLING_DATE_CHANGED';
export const CLEAR_BILLING_DATE_CHANGE = 'CLEAR_BILLING_DATE_CHANGE';

const endpoint = '/billingsubscriptions/subscription/billdate/change';

export default () => async (dispatch, getState) => {
  const state = getState();

  const { selectedBillDate } = state.billingDateSelection;

  dispatch({ type: CHANGE_BILLING_DATE });

  const changed = {
    type: BILLING_DATE_CHANGED,
  };

  try {
    const requestBody = {
      method: 'PUT',
      body: {
        selectedBillDate,
      },
    };
    const changeResult = await dispatch(fetch(endpoint, requestBody));
    changed.payload = { ...changeResult.data[0] };
  } catch (error) {
    const errorMessage = {
      heading: errorMessages.someDataMissing,
      messages: [errorMessages.technicalIssues],
    };

    changed.error = true;
    changed.payload = new Error(JSON.stringify(errorMessage));
  }

  dispatch(changed);
};

export const clearChangeResultData = () => ({
  type: CLEAR_BILLING_DATE_CHANGE,
});
